import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAdvisor } from '@/lib/advisor-context';
import { HomePage } from '@/components/prototype/home-page';
import { WorkspacePage } from '@/components/prototype/workspace-page';
import { IdentitySheets } from '@/components/prototype/identity-sheets';

export function AdvisorPage() {
  const { appView, begin, beginWithAsk } = useAdvisor();
  const location = useLocation();
  const navigate = useNavigate();
  const handledDeepLink = useRef(false);

  // /chat is the app itself; /chat?q=… carries a first message (landing ask-bar,
  // campaign links). Guarded so StrictMode's double effect can't send twice.
  useEffect(() => {
    if (handledDeepLink.current) return;
    handledDeepLink.current = true;
    if (!location.pathname.startsWith('/chat')) return;
    const q = new URLSearchParams(location.search).get('q');
    if (q && q.trim()) {
      beginWithAsk(q);
      navigate('/chat', { replace: true });
    } else if (appView === 'home') {
      begin();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {appView === 'home' ? <HomePage /> : <WorkspacePage />}
      <IdentitySheets />
    </>
  );
}
